<template>
  <div id="currency">
    <div v-if="hideDataNoPlanUser">
      <UpgradeIcon :size="18" :tooltipText="$t('views.common.upgradeIcon.hideDataNoPlanUser')" />
    </div>
    <div
      v-else
      :class="{
        'softRed--text': !hideValue && textRed,
        'softGreen--text': !hideValue && textGreen,
        strong,
        blurred: hideValue,
      }"
    >
      {{ valueAsString }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getCurrencyValueAsString } from '@/lib/utils/currencies.js'
import UpgradeIcon from '@/views/components/common/upgrade/UpgradeIcon'

export default {
  components: { UpgradeIcon },
  props: {
    value: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      default: '',
    },
    negative: {
      type: Boolean,
      default: false,
    },
    textRed: {
      type: Boolean,
      default: false,
    },
    textGreen: {
      type: Boolean,
      default: false,
    },
    strong: {
      type: Boolean,
      default: false,
    },
    decimals: {
      type: Number,
      default: 2,
    },
    showPositive: {
      type: Boolean,
      default: false,
    },
    showNegative: {
      type: Boolean,
      default: true,
    },
    neverHide: {
      type: Boolean,
      default: false,
    },
    hideDataNoPlanUser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['hideAmounts']),
    hideValue() {
      return this.hideAmounts && !this.neverHide
    },
    valueAsString() {
      return getCurrencyValueAsString({
        value: this.value,
        currency: this.currency,
        decimals: this.decimals,
        negative: this.negative,
        showPositive: this.showPositive,
        showNegative: this.showNegative,
        notGrouping: this.hideValue,
      })
    },
  },
}
</script>

<style lang="scss">
#currency {
  .strong {
    font-weight: 600;
  }
  .blurred {
    color: transparent; /* Make the original text transparent */
    text-shadow: 0 0 13px rgba(0, 0, 0, 0.5); /* Add a shadow with blur effect */
    font-weight: 200;
  }
}
.theme--dark {
  #currency {
    .blurred {
      text-shadow: 0 0 13px rgba(255, 255, 255, 0.5); /* Add a shadow with blur effect */
    }
  }
}
</style>
